module.exports = __webpack_public_path__ + "img/PN.4250019f.png";